import { z } from 'zod';
import { CmsImageSchema, CmsLinkSchema, CmsShortTextSchema } from '$cms/types';
import type { SchemaType } from '$util/schema';
import type { SideBySideColors } from './types';
import { SideBySideColorsSchema } from './types';

export { SideBySideColorsSchema };

export const defaultSideBySideColor: SideBySideColors = {
  backgroundColor: 'transparent',
  ctaBackgroundColor: 'white', // @TODO // vars.quantumverse.reskinColors.neutral100,
};

export const defaultConfiguration = {
  headingsPosition: 'text-column' as const,
  mediaColumn: 1 as const,
  textRatio: 5,
  accordionOrMediaRatio: 5,
  colors: defaultSideBySideColor,
};

export const SideBySideMediaBaseSchema = {
  translatedEntities: z.object({
    heading: CmsShortTextSchema,
    subheading: CmsShortTextSchema.optional(),
    image: CmsImageSchema.optional(),
    videoUrl: CmsLinkSchema.optional(),
    videoTitle: CmsShortTextSchema.optional(),
    videoTag: CmsShortTextSchema.optional(),
  }),
  configuration: z
    .object({
      /**
       * @default text-column
       */
      headingsPosition: z.enum(['media-column', 'top-center', 'text-column']).optional(),
      /**
       * In what column will be the image/video positioned.
       * @default 1
       */
      mediaColumn: z.union([z.literal(1), z.literal(2)]).optional(),
      /**
       * Ratio of how wide text box should be,
       * textRatio + accordionOrMediaRatio should not be > 12
       * @default 5
       */
      textRatio: z.number().optional(),
      /**
       * Ratio of how accordion or media box should be
       * accordionOrMediaRatio + textRatio should not be > 12
       * @default 5
       */
      accordionOrMediaRatio: z.number().optional(),
      colors: SideBySideColorsSchema.optional(),
    })
    .default(defaultConfiguration),
};

export type SideBySideMediaBaseTranslatedEntities = SchemaType<
  (typeof SideBySideMediaBaseSchema)['translatedEntities']
>;
export type SideBySideMediaBaseConfiguration = SchemaType<
  (typeof SideBySideMediaBaseSchema)['configuration']
>;
